var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"inline-flex brdr-none",attrs:{"type":"button","data-testid":"returnButton"},on:{"click":_vm.goBack}},[_c('i',{staticClass:"icon-chevron-left"})])}
var staticRenderFns = []

export { render, staticRenderFns }